module.exports = __webpack_public_path__ + "media/point-3.186ab1ff.wav";